import ROUTES from "../../../configs/routesConfig";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useHasDashBoardAccess } from "../../../lib/PermissionContainer/hooks/useHasDashboardAccess";
import USER_ROLES from "../../../types/UserRoles";
import { useCallback } from "react";

export const useRedirectToPortal = () => {
  const navigate: NavigateFunction = useNavigate();

  const { canViewDashboard } = useHasDashBoardAccess();

  const redirect = useCallback(
    (data: any) => {
      const role =
        data["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

      let path: string;

      if (role === USER_ROLES.INTEGRATION_RECEPTIONIST) {
        path = ROUTES.PROFILE;
      } else if (role !== USER_ROLES.PORTAL_USER) {
        path =
          ROUTES[
            canViewDashboard &&
            [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(role)
              ? "DASHBOARD"
              : "ACCOUNTS"
          ];
      } else {
        path = ROUTES.ACCOUNTS;
      }

      navigate(path);
    },
    [canViewDashboard, navigate],
  );

  return { redirect };
};
